module.exports = __webpack_public_path__ + "static/img/bonuses03.a6c926c.webp";